export enum UserLoginStatus {
  Pending = 0,
  Activo = 1,
  Deshabilitado = 2,
  Bloqueado = 3
}

export const UserLoginStatusLabels: Record<UserLoginStatus, string> = {
  [UserLoginStatus.Pending]: 'Pendiente activación',
  [UserLoginStatus.Activo]: 'Activo',
  [UserLoginStatus.Deshabilitado]: 'Deshabilitado',
  [UserLoginStatus.Bloqueado]: 'Bloqueado'
};